import ProductStrip from '_components/ProductStrip';
import type { AlgonomyPlacement } from '@components/global/Recommendations/Loader';

export interface AlgonomyPlacementCarouselProps {
  placement?: AlgonomyPlacement;
  coOpBrand?: string | null;
}

// coOpBrand is accepted via AlgonomyPlacementCarouselProps, ready for the
// follow-up GA4 ticket — it is not yet used in any tracking call.
const AlgonomyPlacementCarousel = ({
  placement,
}: AlgonomyPlacementCarouselProps) => {
  if (!placement) return null;
  // CIP/CLP slice zones already apply their own consistent margin after
  // every slice, so this carousel opts out of ProductStrip's own bottom
  // padding to avoid stacking the two.
  return <ProductStrip placement={placement} noBottomSpacing />;
};

export default AlgonomyPlacementCarousel;
